module.exports = __webpack_public_path__ + "static/media/ic_check.09176b7a.svg";